import { render } from "./SkeletonFeaturedSlide.vue?vue&type=template&id=6bac18c0"
import script from "./SkeletonFeaturedSlide.vue?vue&type=script&lang=js"
export * from "./SkeletonFeaturedSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__